import { tokenState } from "./tokenState";
import { httpClient, post } from "../api/http";
import { LoginResponse } from "../api/endpoints/auth";

export async function login(email: string, password: string) {
  const response = await post(
    "/auth/login/",
    {
      username: email,
      password,
    },
    true
  ) as LoginResponse;
  // Handle the new response structure
  if (response.data) {
    tokenState.setAccessToken(response.data.access_token);
    tokenState.setUsername(response.data.user.username);
    tokenState.setUserData(response.data.user);
  }
}

export async function signUp(
  username: string,
  password: string,
  confirm_password: string,
  email: string,
  first_name: string,
  last_name: string,
  organization_name: string
) {
  const response = await post(
    "/auth/register/",
    {
      username,
      password,
      confirm_password,
      email,
      first_name,
      last_name,
      organization_name,
    },
    true
  );
}

export const changePassword = async (
  oldPassword: string,
  newPassword: string
) => {
  return httpClient.patch(`/v1/change_password/`, {
    old_password: oldPassword,
    new_password: newPassword,
  });
};

export const setNewForgotPassword = async (token: string, Password: string) => {
  return httpClient.patch(`v1/reset_password/`, {
    token: token,
    password: Password,
  });
};

export async function logout() {
  localStorage.removeItem("isRefreshed");
  localStorage.removeItem("access");
  tokenState.clearTokens();
  window.location.href = "/login";
}

export const forgetPassword = async (email: string) => {
  const response = await post("/v1/forgot_password/", { email }, true);
};
